import { useCallback } from 'react';
import type { Sport } from '@betterpool/api-types/contests-service';

import { Routes } from '~/domains/common/constants/routes';
import { URLQueryKeys } from '~/domains/common/types/URLQueryKeys';

import { useIsGamecenterEnabledCallback } from './useIsGamecenterEnabled';

const useGetGamecenterPathCallback = () => {
  const isGamecenterEnabled = useIsGamecenterEnabledCallback();

  return useCallback(
    ({
      contestId,
      contestStatus,
      userEntriesCount,
      currentSlateStatus,
      contestType,
      sport,
      promoSource,
      promoIndex,
  }: Parameters<typeof Routes.gamecenter>[0] & { sport: Sport }) => {
    if (isGamecenterEnabled(contestType, sport)) {
      return Routes.gamecenter({
        contestId,
        contestStatus,
        userEntriesCount,
        currentSlateStatus,
        contestType,
      })
    }
    return Routes.contestDetail(contestId, {
      [URLQueryKeys.UTM_SOURCE]: promoSource,
      [URLQueryKeys.UTM_CAMPAIGN]: `${promoIndex}`,
    })
  }, [isGamecenterEnabled])
};

export default useGetGamecenterPathCallback;
